import { createAction } from '@reduxjs/toolkit'

export const getPAChild = createAction('authorizations/GET_P_A_CHILD')
export const getPAChildSuccessful = createAction(
  'authorizations/GET_P_A_CHILD_SUCCESSFUL'
)
export const getPAChildFailure = createAction(
  'authorizations/GET_P_A_CHILD_FAILURE'
)
